import * as React from "react";
import {MdCheck} from "react-icons/md";
import {Translate} from "react-localize-redux";
import { UncontrolledTooltip, Button } from "reactstrap";
import { FaQuestionCircle } from "react-icons/fa";
import "./PackageCard.scss";
import Number from "./Number";

interface IPackage {
  disabled?: boolean;
  features?: string[];
  price?: number;
  sku: string;
  tooltipText?: string;
}
interface IProps {
  package: IPackage;
  packageSelected: any;
  recommended?: boolean;
  selected?: boolean;
}
interface IState {
  isHovered: boolean;
}
class PackageCard extends React.Component<IProps, IState> {
  private tooltipRef: React.RefObject<HTMLElement> = React.createRef();

  public constructor(props: IProps) {
    super(props);

    this.state = {
      isHovered: false
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleHover = this.handleHover.bind(this);
  }

  public render() {
    return (
      <div
        className={"package-card card " + (this.state.isHovered && !this.props.package.disabled ? "shadow" : "") + (this.props.package.disabled ? " disabled" : "")}
        onMouseEnter={this.handleHover}
        onMouseLeave={this.handleHover}
      >
      {!this.props.package.tooltipText ? null : (
          <span>
            <span className="help-tooltip" ref={this.tooltipRef}>
              <FaQuestionCircle />
            </span>
            {this.tooltipRef.current ? (
              <UncontrolledTooltip placement="right" target={this.tooltipRef.current} autohide={false}>
                {this.props.package.tooltipText}
              </UncontrolledTooltip>
            ) : null}
          </span>
        )}
        <div className="card-body">
          <div className="card-title text-center">
            <h3>
              <Translate id={this.props.package.sku + ".name"} />
            </h3>
          </div>
          <div className="card-text text-center">
            <div>
              <Translate id={this.props.package.sku + ".description"} />
            </div>
            <hr />
            {(this.props.package.features || []).map((f: string, idx: number) => {
              return (
                <div className="small" key={idx}>
                  <Translate id={f} />
                </div>
              );
            })}
          </div>
        </div>
        <div className="card-footer text-center border-0">
          <div className={"price " + (this.props.package.disabled ? "d-none" : "")}>
            <Number value={this.props.package.price || NaN} decimals={0} />{" "}
            <span>
              <Translate id="EuroPerMonth" />
            </span>
          </div>
          <div className={"tax mb-2 " + (this.props.package.disabled ? "d-none" : "")}>
            <Translate id="Tax0" />
          </div>
          <Button
            tabIndex={0}
            onClick={this.handleClick}
            className={"btn btn-primary btn-block " + (this.props.selected ? "btn-success p-0" : "")}
            disabled={this.props.package.disabled}
          >
            {!this.props.package.disabled ? (
              <span>
                <span className={"checked " + (this.props.selected ? "visible" : "invisible")}>
                  <MdCheck />
                </span>
                <span className={"unchecked " + (!this.props.selected ? "visible" : "invisible")}>
                  <Translate id="Select" />
                </span>
              </span>
            ) : (
              <span className={"unchecked "}>
                <Translate id="NonSelectable" />
              </span>
            )}
          </Button>
        </div>
        {this.props.recommended ? (
          <div className="recommended-badge text-uppercase">
            <span>
              <Translate id="Popular" />
            </span>
          </div>
        ) : null}
      </div>
    );
  }

  private handleClick() {
    if (!this.props.package.disabled) {
      this.props.packageSelected(this.props.package.sku);
    }
  }

  private handleHover() {
    this.setState({
      isHovered: !this.state.isHovered
    });
  }
}

export default PackageCard;
